import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function StickyConsultationCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-10 right-6 z-50 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0 pointer-events-none"
      }`}
    >
      <Link
        to="/contact"
        className="group flex items-center gap-2 sm:gap-3 bg-zayan-gold text-zayan-bg px-3 sm:px-5 py-2 sm:py-3 text-xs tracking-[0.12em] font-sans hover:bg-zayan-goldLight transition-colors shadow-lg whitespace-nowrap"
      >
        <span className="w-5 h-5 sm:w-7 sm:h-7 flex items-center justify-center rounded-full bg-zayan-bg/15">
          <i className="ri-calendar-line text-xs sm:text-sm" />
        </span>
        <span className="hidden sm:inline">SCHEDULE CONSULTATION</span>
        <span className="sm:hidden">BOOK NOW</span>
      </Link>
    </div>
  );
}